module.exports = __webpack_public_path__ + "img/vespa_240.a049fa42.png";